// services/categoryTranslationService.js
import api from './api';

/**
 * Service pour gérer les traductions des catégories
 */
class CategoryTranslationService {
  /**
   * Régénérer tous les fichiers de traduction des catégories
   * @returns {Promise} Résultat de la régénération
   */
  async regenerateTranslations() {
    try {
      const response = await api.post('/categories/regenerate-translations');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la régénération des traductions:', error);
      throw error;
    }
  }

  /**
   * Traduire en masse toutes les catégories (titre + description) via DeepL,
   * puis régénérer les fichiers de traduction.
   */
  async autoTranslateAllCategories() {
    try {
      const response = await api.post('/category-translations/auto-translate-all');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la traduction en masse des catégories:', error);
      throw error;
    }
  }

  /**
   * Obtenir toutes les traductions des catégories
   * @returns {Promise} Liste des catégories avec leurs traductions
   */
  async getCategoryTranslations() {
    try {
      const response = await api.get('/category-translations');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des traductions:', error);
      throw error;
    }
  }

  /**
   * Créer ou modifier une traduction pour une catégorie
   * @param {string} categoryId - ID de la catégorie
   * @param {string} language - Code de la langue (fr, en, ar)
   * @param {string} translatedName - Nom traduit
   * @returns {Promise} Résultat de l'opération
   */
  async updateCategoryTranslation(categoryId, language, translatedName) {
    try {
      const response = await api.post('/category-translations', {
        categoryId,
        language,
        name: translatedName
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la traduction:', error);
      throw error;
    }
  }

  /**
   * Supprimer une traduction
   * @param {string} categoryId - ID de la catégorie
   * @param {string} language - Code de la langue
   * @returns {Promise} Résultat de l'opération
   */
  async deleteCategoryTranslation(categoryId, language) {
    try {
      const response = await api.delete(`/category-translations/${categoryId}/${language}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la traduction:', error);
      throw error;
    }
  }
}

const categoryTranslationService = new CategoryTranslationService();
export default categoryTranslationService;
